import { PageItem } from '@src/types';

import {
  Actions,
  Language,
  Message,
  Theme,
  TourFilter,
  UI_HIDE_SNACKBAR,
  UI_SET_HOME,
  UI_SET_IMMIGRATION_HOME,
  UI_SET_LANGUAGE,
  UI_SET_PRIME_HOME,
  UI_SET_SEARCH,
  UI_SET_THEME,
  UI_SET_TOUR_FILTER,
  UI_SET_TOUR_HOME,
  UI_SET_TOUR_SEARCH,
  UI_SET_VERSION,
  UI_SHOW_SNACKBAR,
  Version,
} from './types';

export const setTheme = (theme: Theme): Actions => {
  return {
    type: UI_SET_THEME,
    payload: theme,
  };
};

export const setLanguage = (language: Language): Actions => {
  return {
    type: UI_SET_LANGUAGE,
    payload: language,
  };
};

export const showSnackBar = (message: Message): Actions => {
  return {
    type: UI_SHOW_SNACKBAR,
    payload: message,
  };
};

export const hideSnackBar = (): Actions => {
  return {
    type: UI_HIDE_SNACKBAR,
  };
};

export const setPrimeHome = (items: PageItem[]): Actions => {
  return {
    type: UI_SET_PRIME_HOME,
    payload: items,
  };
};
export const setImmigrationHome = (items: PageItem[]): Actions => {
  return {
    type: UI_SET_IMMIGRATION_HOME,
    payload: items,
  };
};
export const setTourHome = (items: PageItem[]): Actions => {
  return {
    type: UI_SET_TOUR_HOME,
    payload: items,
  };
};

export const setVersion = (version?: Version): Actions => {
  return {
    type: UI_SET_VERSION,
    payload: version,
  };
};

export const setSearch = (search: string): Actions => {
  return {
    type: UI_SET_SEARCH,
    payload: search,
  };
};

export const setTourSearch = (search: string): Actions => {
  return {
    type: UI_SET_TOUR_SEARCH,
    payload: search,
  };
};

export const setTourFilter = (filter: TourFilter): Actions => {
  return {
    type: UI_SET_TOUR_FILTER,
    payload: filter,
  };
};

export const setHome = (items: PageItem[]): Actions => {
  return {
    type: UI_SET_HOME,
    payload: items,
  };
};
